/* unplugin-vue-components disabled */import script from "./SqlJsonPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SqlJsonPage.vue?vue&type=script&setup=true&lang=js"

import "./SqlJsonPage.vue?vue&type=style&index=0&id=17bbabb6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17bbabb6"]])

export default __exports__